import { ANNOTATE_DRAW_TOOL_IDS } from './constants';

/**
 * Resolve Draw-tab tool id + annotation id from a Konva event target (`name`, not class name).
 */
const getAnnotateToolIdFromKonvaNode = (node) => {
  let current = node;
  while (current) {
    const toolId = current.name?.();
    const annotationId = current.id?.();
    if (
      toolId &&
      annotationId &&
      ANNOTATE_DRAW_TOOL_IDS.includes(toolId)
    ) {
      return { toolId, annotationId };
    }
    current = current.getParent?.();
  }
  return null;
};

export default getAnnotateToolIdFromKonvaNode;
